<script setup>
import { Link } from '@inertiajs/vue3';
defineProps({ groups: { type: Array, required: true }, locale: { type: String, default: 'fr' } });
</script>

<template>
    <footer class="border-t border-slate-200 bg-white px-5 pb-6 pt-8 text-sm text-neutral sm:px-8 sm:pt-12 [&_a:focus-visible]:outline [&_a:focus-visible]:outline-2 [&_a:focus-visible]:outline-red-600 [&_a:focus-visible]:outline-offset-4" :aria-label="locale === 'en' ? 'Footer navigation' : 'Navigation de pied de page'">
        <div class="mx-auto max-w-[1120px]">
            <div class="grid gap-6 sm:grid-cols-3 sm:gap-8">
                <nav v-for="group in groups" :key="group.title" :aria-label="group.title">
                    <h2 class="mb-4 font-semibold text-secondary">{{ group.title }}</h2>
                    <ul class="grid gap-2">
                        <li v-for="link in group.links" :key="link.href">
                            <Link v-if="link.inertia" :href="link.href" class="inline-block py-1 hover:text-primary hover:underline">{{ link.label }}</Link>
                            <a v-else :href="link.href" class="inline-block py-1 hover:text-primary hover:underline">{{ link.label }}</a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="mt-8 flex flex-wrap items-center justify-between gap-4 border-t border-slate-200 pt-6">
                <Link :href="locale === 'en' ? '/en' : '/'">© {{ new Date().getFullYear() }} SportsDock</Link>
                <a href="https://dockweb.ca" target="_blank" rel="noopener noreferrer" class="hover:underline">{{ locale === 'en' ? 'By DockWeb' : 'Par DockWeb' }}</a>
            </div>
        </div>
    </footer>
</template>
